var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1699 15.4401L19.9999 20.55L28.7699 15.47",
    stroke: "#B7B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.61V20.54",
    stroke: "#B7B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3901 17.1701C10.3901 15.7901 11.3801 14.1101 12.5901 13.4401L17.9301 10.4701C19.0701 9.84006 20.9401 9.84006 22.0801 10.4701L27.4201 13.4401C28.6301 14.1101 29.6201 15.7901 29.6201 17.1701V22.8201C29.6201 24.2001 28.6301 25.8801 27.4201 26.5501L22.0801 29.5201C20.9401 30.1501 19.0701 30.1501 17.9301 29.5201L12.5901 26.5501C11.3801 25.8801 10.3901 24.2001 10.3901 22.8201V22.0001",
    stroke: "#B7B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 21.24V17.58L18.9297 14.07L17.8798 13.47L15.5098 12.1",
    stroke: "#B7B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.ff9b9a30231a448fead5bb2a5945e2be.svg";
export { ForwardRef as ReactComponent };